// 目標設定画面
import React, { useState, useCallback, useEffect } from 'react';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import {
  Button,
  IconButton,
  ButtonGroup,
  Theme,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar,
  Grid,
  useMediaQuery,
  FormControl
} from '@material-ui/core';
import Popper, { PopperPlacementType } from '@material-ui/core/Popper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import { useHistory, Redirect } from 'react-router-dom';
import './List.css';
import { withStyles, makeStyles, createStyles } from '@material-ui/core/styles';
import { useRecoilState } from 'recoil';
import {
  mainBlueColor,
  isLoggedIn,
  btnColor,
  employeeMasterData,
  userMenuId,
  userRole
} from '../GlobalState';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import {
  getSalesSetting,
  saveSalesSetting,
  getSalesValues,
  updateSalesSetting,
  deleteSalesSetting
} from '../apicalls/salesSetting';

import { getEmployeeMasterList } from '../apicalls/employeeMaster';
import LoadingComponent from '../components/LoadingComponent';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import NumberInput from '../components/NumberInput';
import { parsePrice } from '../utils';
import { parsePercentage } from '../utils';
import { YearPickerInput } from '../components/atoms';
import { NotFoundPage } from './NotFoundPage';
import { BasicSelect } from '../components/parts/input/BasicSelect';
import { getUserSelectOptions } from '../utils/processAndTaskFormUtils';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

class ExtendedUtils extends DateFnsUtils {
  getYearText = (date: Date): string => {
    return `${date.getFullYear()}年`;
  };
}

export const TargetValueSetting: React.FC = () => {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputPriceContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 60,
        alignItems: 'center',
        width: '100%',
        justifyContent: 'right'
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        height: 40,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      text: {
        fontSize: 18,
        fontWeight: 'bold',
        marginBottom: 10,
        marginLeft: 15
      },
      main: {
        minWidth: 700
      },
      table: {
        backgroundColor: `${mainColor} !important`,
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: 16
      },
      table1: {
        // minWidth: 140,
        backgroundColor: mainColor,
        color: '#FFFFFF',
        fontWeight: 'bold'
      },
      inputBottom: {
        height: 30,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        height: 48,
        width: '100%'
      },
      formControl: {
        minWidth: 120
      },
      formControl1: {
        minWidth: 100
      },
      popper: {
        marginVertical: 'auto',
        marginHorizontal: 'auto',
        marginTop: '.5rem'
      },
      arrow: {
        marginTop: '.5rem',
        position: 'absolute',
        bottom: '100%',
        right: '11px',
        transform: 'translateX(-50%)',
        width: 0,
        height: 0,
        borderBottom: '7px solid ' + buttonColor,
        borderRight: '7px solid transparent',
        borderLeft: '7px solid transparent'
      }
    })
  );

  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const [userPermission] = useRecoilState(userRole);

  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [salesSettingData, setSalesSettingData] = useState<any>([]);

  const history: any = useHistory();
  const classes = useStyles();
  const matches2 = useMediaQuery('(min-width:900px)');

  const [loggedIn, setLoggedIn] = useRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  const [employeeMasterApiData, setEmployeeMasterApiData] =
    useRecoilState(employeeMasterData);
  const changeEmployeeMasterApiData = useCallback(
    (newData: any) => setEmployeeMasterApiData(newData),
    [setEmployeeMasterApiData]
  );

  const [userData, setUserData] = useState<any>(
    employeeMasterApiData !== null ? employeeMasterApiData : []
  );

  const [startYear, setStartYear] = useState('');
  const [endYear, setEndYear] = useState('');
  const [startMonth, setStartMonth] = useState('');
  const [endMonth, setEndMonth] = useState('');

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [selectedStartDate, setSelectedStartDate] = useState<Date | null>(null);
  const [selectedEndDate, setSelectedEndDate] = useState<Date | null>(null);

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
    setTargetYear(String(date?.getFullYear()));
  };

  const handleStartDateChange = (date: Date | null) => {
    setSelectedStartDate(date);
    setStartYear(String(date?.getFullYear()));
  };

  const handleEndDateChange = (date: Date | null) => {
    setSelectedEndDate(date);
    setEndYear(String(date?.getFullYear()));
  };

  const [loading, setLoading] = useState(true);
  const [targetYear, setTargetYear] = useState('');
  const [targetMonth, setTargetMonth] = useState('');
  const [target, setTarget] = useState<number>(0);
  const [salesAmount, setSalesAmount] = useState<number>(0);
  const [grossProfit, setGrossProfit] = useState<number>(0);
  const [numberOfBusinessProjects, setNumberOfBusinessProjects] =
    useState<number>(0);
  const [numberOfConstructionProjects, setNumberOfConstructionProjects] =
    useState<number>(0);
  const [numberOfCompletedProjects, setNumberOfCompletedProjects] =
    useState<number>(0);
  const [salesDataExists, setSaleDataExists] = useState<boolean>(false);
  const [userMenu] = useRecoilState<any>(userMenuId);

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  const getListOfSalesSetting = () => {
    getSalesSetting(target, startYear, startMonth, endYear, endMonth).then(
      data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setSalesSettingData(data.data);
              setLoading(false);
            }
          }
        }
      }
    );
  };

  const getListOfSalesSettingDefault = useCallback(() => {
    if (loading === true) {
      getSalesSetting(target, startYear, startMonth, endYear, endMonth).then(
        data => {
          if (data === 'Not logged in!') {
            changeLoggedInData('Not logged in!');
          } else {
            if (typeof data === 'string') {
              setErrorMessage(data);
              setOpen(true);
            } else {
              if (data.error) {
                setErrorMessage(data.error);
                setOpen(true);
              } else {
                setSalesSettingData(data.data);
                setLoading(false);
              }
            }
          }
        }
      );
    }
  }, [
    changeLoggedInData,
    target,
    startYear,
    startMonth,
    endYear,
    endMonth,
    loading
  ]);

  const getListOfUsers = useCallback(() => {
    getEmployeeMasterList('', 1).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            changeEmployeeMasterApiData(data.data);
            setUserData(data.data);
          }
        }
      }
    });
  }, [changeLoggedInData, changeEmployeeMasterApiData]);

  const getSalesSettingData = useCallback(() => {
    getSalesValues(target, targetYear, targetMonth).then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            if (data.data.sales !== '' && salesAmount === 0) {
              setSalesAmount(data.data.sales);
            }
            if (data.data.gross_profit !== '') {
              setGrossProfit(data.data.gross_profit);
            }
            if (data.data.no_of_business_projects !== '') {
              setNumberOfBusinessProjects(data.data.no_of_business_projects);
            }
            if (data.data.no_of_construction_projects !== '') {
              setNumberOfConstructionProjects(
                data.data.no_of_construction_projects
              );
            }
            if (data.data.no_of_completed_projects !== '') {
              setNumberOfCompletedProjects(data.data.no_of_completed_projects);
            }
          }
          if (
            data.data.sales === '' &&
            data.data.gross_profit === '' &&
            data.data.no_of_business_projects === '' &&
            data.data.no_of_construction_projects === '' &&
            data.data.no_of_completed_projects === ''
          ) {
            setSaleDataExists(false);
          } else {
            setSaleDataExists(true);
          }
        }
      }
    });
  }, [
    changeLoggedInData,
    target,
    targetYear,
    targetMonth,
    salesDataExists,
    salesAmount
  ]);

  useEffect(() => {
    getListOfSalesSettingDefault();
    getListOfUsers();
  }, [getListOfSalesSettingDefault, getListOfUsers]);

  useEffect(() => {
    getSalesSettingData();
  }, [getSalesSettingData]);

  const initialState = () => {
    setOpenSuccess(true);
    getListOfSalesSetting();
    setTargetYear('');
    setTargetMonth('');
    setSalesAmount(0);
    setGrossProfit(0);
    setNumberOfBusinessProjects(0);
    setNumberOfConstructionProjects(0);
    setNumberOfCompletedProjects(0);
    setSelectedDate(null);
  };

  const saveSalesSettingDetails = () => {
    if (targetYear === '') {
      setErrorMessage('対象年 必須');
      setOpen(true);
    } else if (targetMonth === '') {
      setErrorMessage('対象月 必須');
      setOpen(true);
    } else if (salesAmount === 0 || isNaN(salesAmount)) {
      setErrorMessage('売上金額 必須');
      setOpen(true);
    } else if (grossProfit === 0 || isNaN(grossProfit)) {
      setErrorMessage('粗利金額 必須');
      setOpen(true);
    } else if (salesDataExists === false) {
      saveSalesSetting(
        targetYear,
        targetMonth,
        target,
        salesAmount,
        grossProfit,
        salesAmount - grossProfit,
        grossProfit / salesAmount,
        numberOfBusinessProjects,
        numberOfConstructionProjects,
        numberOfCompletedProjects
      ).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setErrorMessage(data.message);
              initialState();
            }
          }
        }
      });
    } else {
      updateSalesSetting(
        targetYear,
        targetMonth,
        target,
        salesAmount,
        grossProfit,
        salesAmount - grossProfit,
        grossProfit / salesAmount,
        numberOfBusinessProjects,
        numberOfConstructionProjects,
        numberOfCompletedProjects
      ).then(data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setErrorMessage('設定を更新しました。');
              initialState();
            }
          }
        }
      });
    }
  };

  const editSalesSettingDetails = () => {
    setPopperOpen(false);
    const editTargetYear = salesSettingData[placement].target_year;
    const editTargetMonth = salesSettingData[placement].target_month.slice(
      0,
      -1
    );
    getSalesValues(target, editTargetYear, editTargetMonth).then(data => {
      handleDateChange(new Date(editTargetYear, 1, 1));
      setTargetMonth(editTargetMonth);
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
      } else {
        if (typeof data === 'string') {
          setErrorMessage(data);
          setOpen(true);
        } else {
          if (data.error) {
            setErrorMessage(data.error);
            setOpen(true);
          } else {
            if (data.data.sales !== '') {
              setSalesAmount(data.data.sales);
            }
            if (data.data.gross_profit !== '') {
              setGrossProfit(data.data.gross_profit);
            }
            if (data.data.no_of_business_projects !== '') {
              setNumberOfBusinessProjects(data.data.no_of_business_projects);
            }
            if (data.data.no_of_construction_projects !== '') {
              setNumberOfConstructionProjects(
                data.data.no_of_construction_projects
              );
            }
            if (data.data.no_of_completed_projects !== '') {
              setNumberOfCompletedProjects(data.data.no_of_completed_projects);
            }
          }
          if (
            data.data.sales === '' &&
            data.data.gross_profit === '' &&
            data.data.no_of_business_projects === '' &&
            data.data.no_of_construction_projects === '' &&
            data.data.no_of_completed_projects === ''
          ) {
            setSaleDataExists(false);
          } else {
            setSaleDataExists(true);
          }
        }
      }
    });
  };

  const deleteSalesSettingDetails = () => {
    setPopperOpen(false);
    const deleteTargetYear = salesSettingData[placement].target_year;
    const deleteTargetMonth = salesSettingData[placement].target_month.slice(
      0,
      -1
    );
    deleteSalesSetting(deleteTargetYear, deleteTargetMonth, target).then(
      data => {
        if (data === 'Not logged in!') {
          changeLoggedInData('Not logged in!');
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else {
              setErrorMessage('設定を削除しました。');
              initialState();
            }
          }
        }
      }
    );
  };

  const [anchorEl, setAnchorEl] =
    React.useState<HTMLButtonElement | null>(null);
  const [popperOpen, setPopperOpen] = React.useState(false);
  const [placement, setPlacement] = React.useState<number>(0);

  const handleClick =
    (newPlacement: number) => (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
      setPopperOpen(prev => placement !== newPlacement || !prev);
      setPlacement(newPlacement);
    };

  if (loggedIn === 'Not logged in!') {
    return <Redirect to='/' />;
  }

  if (userMenu == 'Storage') {
    return (
      <Redirect
        to={{
          pathname: '/constructions'
        }}
      />
    );
  }

  if (userPermission === 2 || userPermission === 3) {
    return <NotFoundPage />;
  }

  return (
    <div>
      <AppBarComponent patternName='sales_setting' />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent isFormGroup={true} />
        </>
      ) : (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>

          <Snackbar
            open={openSuccess}
            autoHideDuration={4000}
            onClose={handleCloseSuccess}
          >
            <Alert onClose={handleCloseSuccess} severity='success'>
              {errorMessage}
            </Alert>
          </Snackbar>

          <Grid container>
            <Grid item xs={matches2 ? 4 : 12}>
              <Divider style={{ backgroundColor: '#FFFFFF', marginLeft: 15 }} />
              <div className={classes.subContainer}>
                <div className={classes.textMainContainer}>
                  <div className={classes.textContainer}>
                    担当者選択<span>*</span>
                  </div>
                </div>
                <div className={classes.inputMainContainer}>
                  <div className={classes.inputContainerSelectBox}>
                    <select
                      value={target}
                      onChange={text => {
                        setTarget(parseInt(text.target.value));
                      }}
                      className={classes.selectBoxStyle}
                    >
                      <option value={0}>全体</option>
                      {getUserSelectOptions(userData)}
                    </select>
                  </div>
                </div>
              </div>
              <Divider style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }} />
            </Grid>
          </Grid>

          <div className='table-top-container-customer'>
            <div
              style={{
                fontWeight: 'bold',
                padding: 15,
                paddingBottom: 0,
                fontSize: 24
              }}
            >
              目標値設定
            </div>
          </div>

          <div style={{ overflow: 'scroll' }}>
            <div style={{ marginBottom: 20 }}>
              <Grid container>
                <Grid item xs={matches2 ? 4 : 12}>
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        対象年<span>*</span> . 対象月<span>*</span>
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputMainContainer}>
                        <div
                          style={{
                            marginLeft: 10,
                            marginRight: 5,
                            backgroundColor: '#FFFFFF',
                            height: 44,
                            paddingLeft: 5,
                            width: '40%'
                          }}
                          className={'select-div-div'}
                        >
                          <YearPickerInput
                            year={selectedDate}
                            onChange={handleDateChange}
                            emptyLabel={'対象年'}
                            maxYear={
                              new Date(
                                new Date().setFullYear(
                                  new Date().getFullYear() + 10
                                )
                              )
                            }
                          />
                        </div>

                        <div style={{ marginRight: 15, width: '60%' }}>
                          <select
                            value={targetMonth}
                            onChange={text => {
                              setTargetMonth(text.target.value);
                            }}
                            className={classes.selectBoxStyle}
                          >
                            <option value=''>選択してください</option>
                            <option value={'1'}>1月</option>
                            <option value={'2'}>2月</option>
                            <option value={'3'}>3月</option>
                            <option value={'4'}>4月</option>
                            <option value={'5'}>5月</option>
                            <option value={'6'}>6月</option>
                            <option value={'7'}>7月</option>
                            <option value={'8'}>8月</option>
                            <option value={'9'}>9月</option>
                            <option value={'10'}>10月</option>
                            <option value={'11'}>11月</option>
                            <option value={'12'}>12月</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        売上金額（円）<span>*</span>
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <NumberInput
                          value={salesAmount !== 0 ? salesAmount : ''}
                          dynamicCalculation={true}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setSalesAmount(parseInt(e.target.value));
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>

                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>
                        粗利金額（円）<span>*</span>
                      </div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div
                        style={{ position: 'relative' }}
                        className={classes.inputContainer}
                      >
                        <NumberInput
                          value={grossProfit !== 0 ? grossProfit : ''}
                          dynamicCalculation={true}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>
                          ) => {
                            setGrossProfit(parseInt(e.target.value));
                          }}
                          className={classes.input}
                        />
                      </div>
                    </div>
                  </div>

                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>原価</div>
                    </div>
                    <div className={classes.inputPriceContainer}>
                      <div style={{ marginRight: 10 }}>
                        {parsePrice(salesAmount - grossProfit)}
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>粗利率</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div style={{ marginLeft: 10 }}>
                        {isNaN(grossProfit / salesAmount) || salesAmount === 0
                          ? ''
                          : (grossProfit / salesAmount) * 100}{' '}
                        %
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>営業案件数</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <input
                          value={
                            numberOfBusinessProjects > 0
                              ? numberOfBusinessProjects
                              : ''
                          }
                          type='number'
                          min='0'
                          onChange={text => {
                            setNumberOfBusinessProjects(
                              parseInt(text.target.value)
                            );
                          }}
                          className={classes.input}
                          onWheel={(e: any) => e.target.blur()}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>工事案件数</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <input
                          value={
                            numberOfConstructionProjects > 0
                              ? numberOfConstructionProjects
                              : ''
                          }
                          type='number'
                          min='0'
                          onChange={text => {
                            setNumberOfConstructionProjects(
                              parseInt(text.target.value)
                            );
                          }}
                          className={classes.input}
                          onWheel={(e: any) => e.target.blur()}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />

                  <div className={classes.subContainer}>
                    <div className={classes.textMainContainer}>
                      <div className={classes.textContainer}>完了案件数</div>
                    </div>
                    <div className={classes.inputMainContainer}>
                      <div className={classes.inputContainer}>
                        <input
                          value={
                            numberOfCompletedProjects > 0
                              ? numberOfCompletedProjects
                              : ''
                          }
                          type='number'
                          min='0'
                          onChange={text => {
                            setNumberOfCompletedProjects(
                              parseInt(text.target.value)
                            );
                          }}
                          className={classes.input}
                          onWheel={(e: any) => e.target.blur()}
                        />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }}
                  />
                </Grid>
              </Grid>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: matches2 ? 'row' : 'column',
                justifyContent: 'space-between'
              }}
            >
              <div
                style={{
                  fontWeight: 'bold',
                  padding: 15,
                  paddingBottom: 0,
                  fontSize: 24
                }}
              >
                過去目標値参照
              </div>

              <div
                className='top-bar-container'
                style={{
                  flexDirection: matches2 ? 'row' : 'column',
                  display: 'flex',
                  alignItems: 'center',
                  padding: 15,
                  paddingBottom: 0
                }}
              >
                <div>
                  <div style={{ marginRight: 5 }}>開始年月</div>
                </div>

                <div
                  style={{
                    height: 32,
                    marginRight: 20,
                    marginBottom: matches2 ? 0 : 10
                  }}
                  className='select-div'
                >
                  <div style={{ paddingLeft: 5 }}>
                    <div>
                      <YearPickerInput
                        year={selectedStartDate}
                        onChange={handleStartDateChange}
                        emptyLabel={'選択してください。'}
                        maxYear={
                          new Date(
                            new Date().setFullYear(
                              new Date().getFullYear() + 10
                            )
                          )
                        }
                      />
                    </div>
                  </div>
                </div>

                <div
                  style={{ marginBottom: !matches2 ? 10 : 0 }}
                  className='select-div'
                >
                  <div style={{ paddingLeft: 5 }}>
                    <FormControl className={classes.formControl}>
                      <BasicSelect
                        value={startMonth}
                        onChange={e => {
                          setStartMonth(e.target.value);
                        }}
                        inputProps={{ 'aria-label': 'age' }}
                        disableUnderline
                      >
                        <option value={''}>選択してください</option>
                        <option value={'1'}>1月</option>
                        <option value={'2'}>2月</option>
                        <option value={'3'}>3月</option>
                        <option value={'4'}>4月</option>
                        <option value={'5'}>5月</option>
                        <option value={'6'}>6月</option>
                        <option value={'7'}>7月</option>
                        <option value={'8'}>8月</option>
                        <option value={'9'}>9月</option>
                        <option value={'10'}>10月</option>
                        <option value={'11'}>11月</option>
                        <option value={'12'}>12月</option>
                      </BasicSelect>
                    </FormControl>
                  </div>
                </div>

                <div>
                  <div style={{ paddingLeft: 5, paddingRight: 5 }}>~</div>
                </div>

                <div>
                  <div style={{ marginRight: 5 }}>終了年月</div>
                </div>

                <div
                  style={{
                    height: 32,
                    marginRight: 20,
                    marginBottom: matches2 ? 0 : 10
                  }}
                  className='select-div'
                >
                  <div style={{ paddingLeft: 5 }}>
                    <div>
                      <YearPickerInput
                        year={selectedEndDate}
                        onChange={handleEndDateChange}
                        emptyLabel={'選択してください。'}
                        maxYear={
                          new Date(
                            new Date().setFullYear(
                              new Date().getFullYear() + 10
                            )
                          )
                        }
                      />
                    </div>
                  </div>
                </div>

                <div
                  style={{ marginBottom: !matches2 ? 10 : 0 }}
                  className='select-div'
                >
                  <div style={{ paddingLeft: 5 }}>
                    <FormControl className={classes.formControl}>
                      <BasicSelect
                        value={endMonth}
                        onChange={e => {
                          setEndMonth(e.target.value);
                        }}
                        inputProps={{ 'aria-label': 'age' }}
                        disableUnderline
                      >
                        <option value={''}>選択してください</option>
                        <option value={'1'}>1月</option>
                        <option value={'2'}>2月</option>
                        <option value={'3'}>3月</option>
                        <option value={'4'}>4月</option>
                        <option value={'5'}>5月</option>
                        <option value={'6'}>6月</option>
                        <option value={'7'}>7月</option>
                        <option value={'8'}>8月</option>
                        <option value={'9'}>9月</option>
                        <option value={'10'}>10月</option>
                        <option value={'11'}>11月</option>
                        <option value={'12'}>12月</option>
                      </BasicSelect>
                    </FormControl>
                  </div>
                </div>

                <div
                  style={{ marginLeft: 20, marginBottom: !matches2 ? 10 : 0 }}
                >
                  <Button
                    style={{ backgroundColor: buttonColor }}
                    variant='contained'
                    color='primary'
                    onClick={() => {
                      getListOfSalesSetting();
                    }}
                  >
                    表示
                  </Button>
                </div>
              </div>
            </div>

            <div style={{ margin: 15 }}>
              <TableContainer component={Paper}>
                <Table className={classes.main} aria-label='customized table'>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell
                        style={{ minWidth: 110 }}
                        className={classes.table}
                        align='left'
                      ></StyledTableCell>
                      {salesSettingData.map((i: any, index: number) => (
                        <StyledTableCell
                          key={index}
                          style={{ minWidth: 110, paddingBottom: 5 }}
                          className={classes.table}
                          align='left'
                        >
                          <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            <div>
                              <div>{i.target_month}</div>
                              <div>{i.target_year}</div>
                            </div>
                            <div>
                              <IconButton
                                style={{
                                  fontSize: 'large',
                                  color: 'white',
                                  paddingTop: '1.5rem',
                                  paddingBottom: 0
                                }}
                                onClick={handleClick(index)}
                              >
                                <KeyboardArrowDownIcon />
                              </IconButton>
                              <Popper
                                className={classes.popper}
                                anchorEl={anchorEl}
                                open={popperOpen}
                                placement='bottom-end'
                                disablePortal={true}
                              >
                                <span className={classes.arrow} />
                                <Paper key={index} elevation={0}>
                                  <ButtonGroup
                                    disableElevation={true}
                                    orientation='vertical'
                                    aria-label='vertical contained button group'
                                    variant='contained'
                                    style={{ backgroundColor: buttonColor }}
                                  >
                                    <div>
                                      <Button
                                        onClick={() => {
                                          editSalesSettingDetails();
                                        }}
                                        style={{
                                          paddingLeft: 40,
                                          paddingRight: 40,
                                          backgroundColor: buttonColor,
                                          color: 'white'
                                        }}
                                      >
                                        編集
                                      </Button>
                                    </div>
                                    <div>
                                      <Button
                                        onClick={() => {
                                          deleteSalesSettingDetails();
                                        }}
                                        style={{
                                          paddingLeft: 40,
                                          paddingRight: 40,
                                          backgroundColor: buttonColor,
                                          color: 'white'
                                        }}
                                      >
                                        削除
                                      </Button>
                                    </div>
                                  </ButtonGroup>
                                </Paper>
                              </Popper>
                            </div>
                          </div>
                        </StyledTableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell className={classes.table1} align='left'>
                        売上金額(円)
                      </StyledTableCell>
                      {salesSettingData.map((i: any) => (
                        <StyledTableCell align='right'>
                          {parsePrice(i.sales)}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell className={classes.table1} align='left'>
                        粗利金額(円)
                      </StyledTableCell>
                      {salesSettingData.map((i: any) => (
                        <StyledTableCell align='right'>
                          {parsePrice(i.gross_profit)}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell className={classes.table1} align='left'>
                        粗利金額（円）
                      </StyledTableCell>
                      {salesSettingData.map((i: any) => (
                        <StyledTableCell align='right'>
                          {parsePrice(i.gross_profit)}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell className={classes.table1} align='left'>
                        原価
                      </StyledTableCell>
                      {salesSettingData.map((i: any) => (
                        <StyledTableCell align='right'>
                          {parsePrice(i.cost)}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell className={classes.table1} align='left'>
                        粗利率
                      </StyledTableCell>
                      {salesSettingData.map((i: any) => (
                        <StyledTableCell align='left'>
                          {parsePercentage(i.gross_profit_rate)}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell className={classes.table1} align='left'>
                        営業案件数
                      </StyledTableCell>
                      {salesSettingData.map((i: any) => (
                        <StyledTableCell align='left'>
                          {i.no_of_business_projects}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell className={classes.table1} align='left'>
                        工事案件数
                      </StyledTableCell>
                      {salesSettingData.map((i: any) => (
                        <StyledTableCell align='left'>
                          {i.no_of_construction_projects}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell className={classes.table1} align='left'>
                        完了案件数
                      </StyledTableCell>
                      {salesSettingData.map((i: any) => (
                        <StyledTableCell align='left'>
                          {i.no_of_completed_projects}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
          <div style={{ height: 120 }} />

          <div
            className='save-btn-container'
            style={{
              backgroundColor: '#FFFFFF',
              position: 'fixed',
              bottom: 0,
              width: '100%',
              display: 'flex',
              justifyContent: 'space-around'
            }}
          >
            <div />
            <div>
              <Button
                onClick={() => {
                  saveSalesSettingDetails();
                }}
                style={{
                  paddingLeft: 50,
                  paddingRight: 50,
                  margin: 20,
                  backgroundColor: buttonColor
                }}
                variant='contained'
                color='primary'
              >
                保存
              </Button>
            </div>
            <div />
          </div>
        </>
      )}
    </div>
  );
};
